import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { Spin } from "antd";
import { getApiBaseUrl, GET_MAINTAIN_STAGES } from "../../Config/Config";

const MaintenanceStages = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMaintenanceStages = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_MAINTAIN_STAGES}`);
      const result = await response.json();
      setData(result?.ResultData || []);
    } catch (error) {
      console.error("Error fetching maintenance stages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaintenanceStages();
  }, []);

  const columns = [
    {
      title: "Stage Name",
      dataIndex: "StageName",
      key: "StageName",
      sorter: (a, b) => a.StageName.localeCompare(b.StageName),
    },
    {
      title: "Stage Order",
      dataIndex: "StageOrder",
      key: "StageOrder",
      sorter: (a, b) => a.StageOrder - b.StageOrder,
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      sorter: (a, b) => a.Description.localeCompare(b.Description),
    },
    {
      title: "Status",
      dataIndex: "IsActive",
      key: "IsActive",
      render: (isActive) => (
        <span className={`badge ${isActive ? "bg-success" : "bg-danger"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Maintenance Stages{" "}
                  </h4>
                </ol>
              </nav>
              <h6>Manage Maintenance Stages</h6>
            </div>
          </div>
        </div>

        <div>
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
              <div className="search-set mt-4"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : data.length > 0 ? (
                  <Table dataSource={data} columns={columns} />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceStages;
